import { useVehicleAvailability } from '~/context/vdp/UserVehicleContext';
import useIsReservableVehicle from './useIsReservableVehicle';

export default function useIsVehicleReservedByUser() {
  const { isLockedByThisUser = false } = useVehicleAvailability();
  const isReservableVehicle = useIsReservableVehicle();

  return isLockedByThisUser && isReservableVehicle;
}
